Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.LogicalValueSetMapper
  constructor: (key, primaryKey, secondaryKey, excludedKey, noValuesIdentifier, allValuesIdentifier) ->
    @intelligent_key = 'intelligent_' + key
    @includedMapper = new CustomerVisualMode.Mappers.IncludedValueSetMapper(
      primaryKey,
      secondaryKey,
      noValuesIdentifier,
      allValuesIdentifier
    )
    @excludedMapper = new CustomerVisualMode.Mappers.ExcludedValueSetMapper(excludedKey)

  mapToCompositeFilter: (searchQuery) ->
    intelligentGroups = searchQuery[@intelligent_key] || {}

    includedValues = @includedMapper.mapToCompositeFilter(intelligentGroups)
    excludedValues = @excludedMapper.mapToCompositeFilter(intelligentGroups)
    _.extend(includedValues, excludedValues)

  mapToSearchQuery: (intelligentGroups) ->
    includedValues = @includedMapper.mapToSearchQuery(intelligentGroups)
    excludedValues = @excludedMapper.mapToSearchQuery(intelligentGroups)
    _.extend(includedValues, excludedValues)
